import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ClipLoader } from "react-spinners";
import { showError } from "helpers/notification_helper";

const CreatePortalLink = ({
  visible,
  handleClose,
  initialData = null,
  onSubmit,
  fieldErrors,
  loading,
}) => {
  const [isSubmitted, setIsSubmitted] = useState(false);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: initialData?.title || "",
      title_ar: initialData?.title_ar || "",
      link: initialData?.link || "",
      status: initialData?.status ?? 1,
    },
    validationSchema: Yup.object({
      title: Yup.string().required("English title is required"),
      title_ar: Yup.string().required("Arabic title is required"),
      link: Yup.string().url("Enter a valid URL").required("Link is required"),
      status: Yup.number().required("Status is required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      if (initialData) {
        onSubmit(values, initialData?.id, resetForm, handleClose);
      } else {
        onSubmit(values, resetForm, handleClose);
      }
    },
  });

  // Handle external validation errors
  useEffect(() => {
    if (fieldErrors) formik.setErrors(fieldErrors);
  }, [fieldErrors]);

  useEffect(() => {
    if (Object.keys(formik.errors).length !== 0 && isSubmitted) {
      showError("Validation Error");
      setIsSubmitted(false);
    }
  }, [formik.errors, isSubmitted]);

  const onClose = () => {
    formik.resetForm();
    handleClose();
  };

  return (
    <Modal
      title={initialData ? "Edit Portal Link" : "Create Portal Link"}
      open={visible}
      onCancel={onClose}
      footer={null}
      destroyOnClose
      centered
      width={600}
      maskClosable={false}
      className="custom-modal-header p-0"
    >
      <form onSubmit={formik.handleSubmit}>
        <div className="row g-3">
          {/* Title EN */}
          <div className="col-md-12">
            <label className="form-label fs-7">
              Title (EN) <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              name="title"
              className="form-control"
              value={formik.values.title}
              onChange={formik.handleChange}
              placeholder="Enter title in English"
            />
            {formik.errors.title && (
              <div className="text-danger">{formik.errors.title}</div>
            )}
          </div>

          {/* Title AR */}
          <div className="col-md-12">
            <label className="form-label fs-7">
              Title (AR) <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              name="title_ar"
              className="form-control"
              value={formik.values.title_ar}
              onChange={formik.handleChange}
              placeholder="Enter title in Arabic"
            />
            {formik.errors.title_ar && (
              <div className="text-danger">{formik.errors.title_ar}</div>
            )}
          </div>

          {/* Link */}
          <div className="col-md-12">
            <label className="form-label fs-7">
              Link <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              name="link"
              className="form-control"
              value={formik.values.link}
              onChange={formik.handleChange}
              placeholder="https://example.com"
            />
            {formik.errors.link && (
              <div className="text-danger">{formik.errors.link}</div>
            )}
          </div>

          {/* Status */}
          <div className="col-md-12">
            <label className="form-label fs-7">
              Status <span className="text-danger">*</span>
            </label>
            <select
              name="status"
              className="form-select"
              value={formik.values.status}
              onChange={formik.handleChange}
            >
              <option value={1}>Active</option>
              <option value={0}>Inactive</option>
            </select>
            {formik.errors.status && (
              <div className="text-danger">{formik.errors.status}</div>
            )}
          </div>
        </div>

        {/* Footer */}
        <div className="modal-footer mt-4">
          <button type="button" className="btn btn-light" onClick={onClose}>
            Close
          </button>
          <button
            type="submit"
            onClick={() => setIsSubmitted(true)}
            className="btn btn-primary ms-3"
            style={{ minWidth: "100px" }}
            disabled={loading}
          >
            {loading ? (
              <ClipLoader size={18} color="white" />
            ) : initialData ? (
              "Update"
            ) : (
              "Add"
            )}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default CreatePortalLink;
